import React from "react";
import "./accordion.css";

function FAQBody() {
  return (
    <>
      <div className="container-fluid p-4 body-font">
        <div
          className="row p-4"
          style={{
            width: "100vw",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="row img-fluid"
            style={{
              backgroundImage:
                "url(https://images.hertz.com/content/dam/hod/images/en-gb/static/FAQ_top.png)",
              backgroundSize: "cover",
            }}
          >
            <div className="col-xs-12 col-md-1"></div>
            <div className="col-xs-12 col-md-5">
              <br />
              <p className="h6">
                <b>FAQs</b>
              </p>
              <p className="h1">
                <b>LEARN MORE</b>
              </p>
              <p>
                We understand that you might have question how Hertz 24/7 works,
                concerms about your invoices or simply would like to know what
                is required to register. This page will answer those questions.
              </p>

              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <div className="col-xs-12 col-md-4"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-3" style={{ textAlign: "left" }}>
            <br />
            <br />

            <p>
              <b>Getting Started</b>
              <br />
              &nbsp;&nbsp;
              <a href="#reg" style={{ textDecoration: "none" }}>
                Registration
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#consup" style={{ textDecoration: "none" }}>
                Contact Support
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#cg" style={{ textDecoration: "none" }}>
                Community Guidelines/Vehicle Sharing Rules
              </a>
            </p>
            <hr />

            <p>
              <b>Making a booking</b>
              <br />
              &nbsp;&nbsp;
              <a href="#book" style={{ textDecoration: "none" }}>
                Your Booking
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#ins" style={{ textDecoration: "none" }}>
                Insurance
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#pac" style={{ textDecoration: "none" }}>
                Pricing and Additional Charges
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#rac" style={{ textDecoration: "none" }}>
                Refuelling and Charging
              </a>
            </p>
            <hr />
            <p>
              <b>Rental Process</b>
              <br />
              &nbsp;&nbsp;
              <a href="#yj" style={{ textDecoration: "none" }}>
                Starting Your Rental
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#ts" style={{ textDecoration: "none" }}>
                Troubleshooting
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#aob" style={{ textDecoration: "none" }}>
                Accidents/Breakdowns
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#rvet" style={{ textDecoration: "none" }}>
                Returning the Vehicle/Ending Your Trip
              </a>
            </p>
            <hr />
            <p>
              <b>Invoicing</b>
              <br />
              &nbsp;&nbsp;
              <a href="#bfi" style={{ textDecoration: "none" }}>
                Billing and fees
              </a>
              <br />
              &nbsp;&nbsp;
              <a href="#pi" style={{ textDecoration: "none" }}>
                Parking Information
              </a>
            </p>
            <hr />
          </div>

          <div className="col-xs-12 col-md-9" style={{ textAlign: "left" }}>
            <br />
            <br />

            <div className="accordion p-4" id="accordionFlushExample">
              <br />
              <p id="reg">
                <b>Registration</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse1"
                    aria-expanded="false"
                    aria-controls="flush-collapse1"
                  >
                    <b>What is Hertz 24/7?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Hertz 24/7™ our vehicle sharing platform which gives you the
                    convenience and flexibility of having access to a wide range
                    of vans and vehicles. You can pick up at any hour of day or
                    night (location opening hours permitting). Hertz 24/7 is a
                    self-service in which you can book and manage your rental
                    all through the 24/7 app. Our aim is that you can start to
                    drive in as little as 15 minutes from downloading the app.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse3"
                    aria-expanded="false"
                    aria-controls="flush-collapse3"
                  >
                    <b>How will I know if my registration has been accepted?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Validations can take up to 10 minutes. If you refresh your
                    app, we’ll show your account status in the Profile section.
                    We’ll also send you an email with the result if your
                    application was approved or rejected.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse4"
                    aria-expanded="false"
                    aria-controls="flush-collapse4"
                  >
                    <b>What happens if my contact details change?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Please log into your Hertz 24/7 profile on the mobile app
                    and amend your account details. For changes of the phone
                    number, driver licence or ID, please reach out to our
                    support team as we’ll need to reset your application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse5"
                    aria-expanded="false"
                    aria-controls="flush-collapse5"
                  >
                    <b>Will my membership expire?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Your membership will be for 1 year and will renew
                    automatically on your membership anniversary date and your
                    account will be charged £5 on that date. We will notify you
                    of this in advance. Just as long as your driving licence is
                    valid and you continue to meet our rental requirements.
                    Other terms and conditions may apply.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading6">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse6"
                    aria-expanded="false"
                    aria-controls="flush-collapse6"
                  >
                    <b>
                      Can I cancel my membership and/or its automatic renewal?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse6"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading6"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Your membership runs for 12 months from the date of your
                    enrolment (the “Membership Term”) and then automatically
                    renews for further 12 month periods (each a “Renewal Term”)
                    unless you cancel your membership or renewal. You can cancel
                    your membership and/or its automatic renewal any time during
                    your Membership Term or a Renewal Term by visiting the Hertz
                    24/7 App and tap My Profile, Loyalty Programs and then
                    Deactivate My Membership. Please be aware that: You can
                    cancel your membership 14 days before the renewal date of
                    your membership and you will not be charged. You will not be
                    able to make new bookings until the membership is
                    reactivated. If you cancel your membership less than 14 days
                    before the end of your Membership Term or any Renewal Term
                    your membership will automatically renew and continue until
                    the end of the next Renewal Term and the membership fee will
                    be charged and will be non-refundable. At the end of this
                    Renewal Term your membership will be deactivated and will
                    not automatically renew again and no further membership fee
                    will be payable, unless you join again.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL1"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL1"
                  >
                    <b>What vehicle models/sizes do you have available?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      <b>Short Wheelbase (SWB) Vans:</b> <br />
                      <br />
                      Ford Custom <br />
                      Vauxhall Vivaro Fiat Scudo <br />
                      Toyota Proace <br />
                      <br />
                      <b>Long Wheelbase (LWB) Vans:</b> <br />
                      <br />
                      Ford Transit <br />
                      Mercedes Sprinter <br />
                      Vauxhall Movano <br />
                      <br />
                      <b>Combo Vans:</b>
                      <br />
                      <br />
                      Vauxhall Combo
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL2"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL2"
                  >
                    <b>How old do I have to be to hire a Hertz 24/7 vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL2"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL2"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      You must be 21 years of age or over to hire and drive one
                      of our vehicles. You also need to have held a full driving
                      licence for at least a year and have had no suspensions in
                      the last 5 years.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL3"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL3"
                  >
                    <b>
                      What details do you require to register for Hertz 24/7?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      To join Hertz 24/7 you’ll need to provide the following
                      details:
                      <br />· A valid driving licence in your own name <br />· A
                      credit or debit card in your own name <br />· Recent proof
                      of address document (for non-UK residents) <br />· Selfie
                      <br />· Your own mobile phone number and your own personal
                      email address. <br />
                      We then complete the necessary ID and address checks
                      before confirming your registration.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL4"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL4"
                  >
                    <b>
                      What are the requirements to set up a Hertz 24/7 account?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>Age:You must be 21 years of age or older.</p>
                    <p>
                      Driving License:You need a full UK driving license that
                      has been held for a minimum of one year.
                    </p>

                    <p>
                      License Restrictions:You'll need a full license, not one
                      restricted to automatic vehicles, as Hertz 24/7 vehicles
                      are manual transmission.
                    </p>

                    <p>
                      Endorsements:Hertz will need to check for any driving
                      endorsements or suspensions on your license, which you can
                      provide by either generating a unique code or printing a
                      license summary from the government website.
                    </p>

                    <p>
                      Payment:A valid credit or debit card in your name is
                      required for the rental and any pre-authorized amounts.
                    </p>

                    <p>
                      Registration:You need to register with Hertz 24/7 and
                      agree to the terms and conditions.
                    </p>

                    <p>
                      Other:To create an account, you will also need to provide
                      your mobile phone number and email address.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL5"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL5"
                  >
                    <b>Is there an annual membership to use Hertz 24/7?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      You can join Hertz 24/7 for just a £5 annual membership
                      fee, after that you pay only for your rentals. What's
                      more, basic insurance and maintenance are included in the
                      rate. The annual membership fee will be charged upon
                      creating your first booking and contributes to the
                      provision of security validation at the start of your
                      membership and sanitisation of vehicles hired throughout
                      your membership. The Hertz 24/7 membership will
                      automatically renew. You'll receive an email when your
                      renewal is upcoming. In case you want to stop the
                      membership, you can cancel the renewal through the app.
                      You’ll find the membership in your Profile under Loyalty
                      Programs.
                    </p>
                    <p>
                      NOTE: Hertz 24/7 customers who are a valid Costco member
                      do not pay the annual membership fee. Please enter your
                      Costco Membership number in the affiliate number field
                      with your first booking.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL6">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL6"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL6"
                  >
                    <b>Will my membership expire?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL6"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL6"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Your membership will be valid for 1 year and will renew
                      automatically on your membership anniversary date. Your
                      primary method of payment will be charged £5 on that date.
                      We will notify you of the renewal in advance via email.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL7">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL7"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL7"
                  >
                    <b>Can I cancel my Hertz 24/7 membership?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL7"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL7"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Your membership runs for 12 months from the date of your
                      enrolment and then automatically renews annually.
                    </p>

                    <p>
                      You can cancel your membership and/or its automatic
                      renewal any time during your Membership Term or a Renewal
                      Term by visiting the Hertz 24/7 App and tap My Profile,
                      Loyalty Programs and then Deactivate My Membership.
                    </p>

                    <p>
                      Please be aware that: Once you cancel your membership, you
                      will not be able to make new bookings until the membership
                      is reactivated.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL8">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL8"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL8"
                  >
                    <b>What equipment is provided in the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL8"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL8"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Each vehicle comes with a spare tyre, a jack and standard
                      tools which vary dependent on the vehicle model. Please
                      note that if you require the following, you will need to
                      bring this yourself to your rental:
                    </p>
                    <br />
                    Child vehicle seats
                    <br />
                    Usb cable
                    <br />
                    Satellite Navigation
                    <br />
                    Ski Rack
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL9">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL9"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL9"
                  >
                    <b>Is the vehicle just for me when I book it?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL9"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL9"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes, during your booking period, the vehicle is
                      exclusively yours. However, Hertz Vehicle Sharing is a
                      shared service, which means the same vehicle is used by
                      different members throughout the day or week. After your
                      booking ends, the vehicle becomes available for the next
                      customer so it is important to be back in time or update
                      your booking accordingly.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading44">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse44"
                    aria-expanded="false"
                    aria-controls="flush-collapse44"
                  >
                    <b>Can I use Hertz 24/7 in any other countries?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse44"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading44"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes. If you’re registered with Hertz 24/7, you can use your
                    account to make bookings at any participating location in
                    the UK, France, Germany, Italy, and Portugal.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading40">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse40"
                    aria-expanded="false"
                    aria-controls="flush-collapse40"
                  >
                    <b>How are your vehicles maintained?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse40"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading40"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    A team of dedicated professionals looks after our fleet of
                    Hertz 24/7 vehicles. In addition to our usual scheduled
                    maintenance, we carry out a monthly 40-point quality check
                    on every vehicle. We also clean and perform safety checks on
                    the vehicles at least twice a month.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingreg40">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsereg40"
                    aria-expanded="false"
                    aria-controls="flush-collapsereg40"
                  >
                    <b>What if my application is rejected?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsereg40"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingreg40"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If we cannot approve your account application, it might be
                    for one of the following potential reasons: <br />
                    • One or more of the submitted documents has expired
                    <br />
                    • Minimum age requirement is not met
                    <br />
                    • Minimum driving experience not met
                    <br />
                    • Driving licence is valid for automatic vehicles only
                    <br />
                    • Driving licence is learner or provisional
                    <br />
                    • Driving licence is not from a European or other accepted
                    country
                    <br />
                    • Could not validate the provided address
                    <br />
                    • Your documents is currently part of the Hertz do not rent
                    list
                    <br />
                    <br />
                    If your account is rejected, any bookings you have made will
                    be automatically cancelled.If you have further questions,
                    please contact our support team via the app.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingreg41">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsereg41"
                    aria-expanded="false"
                    aria-controls="flush-collapsereg41"
                  >
                    <b>
                      How do I submit viable photos and documents for the
                      verification check?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsereg41"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingreg41"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      When submitting documents and taking your selfie for the
                      preregistration checks, it’s important to note the
                      following:{" "}
                    </p>
                    - When taking the photos, try to prevent glare and blur.
                    <br />
                    - Documents should not have expired.
                    <br />
                    - Pictures of photocopies or screen are not accepted.
                    <br />
                    - Each markets have different age and licence duration
                    requirements. At time of booking you will be prompted on
                    requirements.
                    <br />
                    <br />
                    <p>
                      Please note:
                      <br />
                      - Paper driver licences can be tricky for our system and
                      you might need to reach out to chat support through the
                      app to get your account validated.
                      <br />- After application, you will receive an email with
                      your application status. If you disagree with a rejection
                      reason, please contact support through chat.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingreg42">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsereg42"
                    aria-expanded="false"
                    aria-controls="flush-collapsereg42"
                  >
                    <b>What do I need to do before starting the rental?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsereg42"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingreg42"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      To begin your rental, download the Hertz 24/7 app from
                      either the Google Play Store or Apple App Store. This app
                      is your central place for starting, managing, and ending
                      your rental. Once installed, you'll need to create a
                      membership profile and upload your documents for
                      verification using the app’s photo feature. After logging
                      in, simply follow the prompts to start your reservation.
                    </p>

                    <p>
                      Before accessing the vehicle, you’ll be asked to complete
                      a few pre-rental checks. This includes taking a selfie
                      that matches your driver’s license and taking photos of
                      the vehicle to document its condition. These images should
                      be uploaded through the app to ensure you’re not held
                      responsible for any pre-existing damage. We allow an
                      additional 15 minutes before the booked start time to
                      complete the checks.{" "}
                    </p>

                    <p>
                      Once the checks are complete, you'll be prompted to sign
                      the rental agreement within the app. After signing, a
                      virtual key will appear, allowing you to unlock the
                      vehicle.
                    </p>

                    <p>
                      Please note, before the start of the rental a hold equal
                      to twice your rental amount will be placed on your payment
                      method. The final invoice will be deducted after your
                      rental ends, and any remaining balance will be released.
                      It’s important to ensure that the full hold amount is
                      available on your payment method, as your rental cannot
                      begin without it. {" "}
                    </p>
                  </div>
                </div>
              </div>
              <br />
              <p id="book">
                <b>Your Booking</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading9">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse9"
                    aria-expanded="false"
                    aria-controls="flush-collapse9"
                  >
                    <b>What if the vehicle I’d like is already booked?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse9"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading9"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If the vehicle you would like to book isn’t available at
                    your preferred location, please pick an alternative time or
                    date, or check availability at other locations nearby.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading12">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse12"
                    aria-expanded="false"
                    aria-controls="flush-collapse12"
                  >
                    <b>Is my payment secure?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse12"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading12"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes. Our payment processor is Stripe. We also follow all
                    appropriate Data Protection legislation regarding personal
                    and financial data.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading13">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse13"
                    aria-expanded="false"
                    aria-controls="flush-collapse13"
                  >
                    <b>
                      How will I be charged when I book a Hertz 24/7 rental?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse13"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading13"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      We will put a preauthorised hold of 200% of the booking
                      value on the selected method of payment 48 hours before
                      you start your rental or immediately if your rental
                      commences within 48 hours.
                    </p>
                    <p>
                      The booking can only commence once the deposit
                      authorisation has been successfully obtained.
                    </p>
                    <p>
                      The pre-authorisations will be released when the invoice
                      is issued. We will deduct the charges and return the
                      remainder. If the rental cost exceeds the deposit, we will
                      capture the exceeded amount separately.
                    </p>
                    <p>
                      Please note, any delay in the deposit being returned will
                      be from your credit or debit card issuing bank.
                    </p>
                     
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading14">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse14"
                    aria-expanded="false"
                    aria-controls="flush-collapse14"
                  >
                    <b>How far in advance can I book a vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse14"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading14"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Depending on the rental station, between three and six
                    months.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading8">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse8"
                    aria-expanded="false"
                    aria-controls="flush-collapse8"
                  >
                    <b>
                      Can other drivers, such as my family, share my membership?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse8"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading8"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      No. The membership is personal and exclusive to you.
                      Please feel free to recommend us though.
                    </p>

                    <p>
                      However, it is possible to add a second driver to your
                      booking. This driver will need an approved Hertz 24/7
                      account. Please note that second drivers can only be added
                      once a rental has started.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook8">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook8"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook8"
                  >
                    <b>How do I make a booking with 24/7?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook8"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook8"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      In order to make a booking you can do so by opening the
                      24/7 app and selecting ‘Book New Rental’. Once selected,
                      you will be prompted to choose the location where you
                      would like to rent a vehicle. You can either use the
                      search function or select one of the close by options on
                      the slider below. You can also select the location from a
                      pin on the map.{" "}
                    </p>

                    <p>
                      Once the location is selected, you will be prompted to
                      select a date and time. Please make sure to select a
                      minimum of one hour in the ‘Pickup’ and ‘Return’ settings,
                      as you will be charged at minimum for one hour.{" "}
                    </p>

                    <p>
                      Once you have selected your booking time and date, you
                      will then be prompted to choose your vehicle. Please
                      select a vehicle and then calculate the estimated price
                      for your planned route.{" "}
                    </p>

                    <p>
                      Following this step, you will be brought to the checkout
                      page. Here you can input any relevant vouchers or codes
                      and then confirm your booking.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook9">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook9"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook9"
                  >
                    <b>How will I know if my booking is confirmed?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook9"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook9"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    We will email you the booking confirmation. Any confirmed
                    bookings are visible in the mobile app under ‘Bookings’.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook10">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook10"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook10"
                  >
                    <b>
                      My booking location has changed, and I cannot accept this
                      change. What do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook10"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook10"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If your booking location has changed and you cannot accept
                    the change, please reach out to chat support via the 24/7
                    app for assistance.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading38">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse38"
                    aria-expanded="false"
                    aria-controls="flush-collapse38"
                  >
                    <b>
                      What if the vehicle I've booked is returned late by the
                      customer before me?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse38"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading38"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    We’ll always try to reach you in time to let you know.
                    However, if you haven’t heard from us, please contact us
                    ASAP and we’ll arrange an alternative vehicle.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook11">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook11"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook11"
                  >
                    <b>
                      The assigned vehicle is a different model than what I
                      booked – what do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook11"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook11"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    In the unlikely event that your booked vehicle model is not
                    available, we may automatically assign a different model at
                    the booked location or find a location nearby. You’ll get
                    notified of these changes. In case you cannot accept the
                    change, please contact our support team through the chat to
                    arrange an alternative.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook12">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook12"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook12"
                  >
                    <b>How do I adjust my booking?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook12"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook12"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    To adjust your booking please go to the 24/7 app and select
                    ‘Bookings’. From here you can select ‘Change Booking’ to
                    adjust your booking such as changes to the time of your
                    pickup/return or changes of vehicle.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook13">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook13"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook13"
                  >
                    <b>How do I cancel a booking? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook13"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook13"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    To cancel your booking, please go to the 24/7 app and select
                    ‘Bookings’. From here you can select ‘Cancel’ under your
                    booking to cancel.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook14">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook14"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook14"
                  >
                    <b>You have cancelled my booking, what do I do now?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook14"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook14"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>Your booking can get cancelled if: </p>

                    <p>Your account has been rejected </p>

                    <p>
                      Due to unforeseen circumstances, we cannot provide a
                      vehicle at your booked or nearby location{" "}
                    </p>

                    <p>
                      Please contact our support team to re-arrange your
                      booking.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading11">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse11"
                    aria-expanded="false"
                    aria-controls="flush-collapse11"
                  >
                    <b>
                      Are there any fees for changing or cancelling my booking?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse11"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading11"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    You can change or cancel your booking up to 6 hours before
                    your vehicle pick-up time free of charge. If it’s within 6
                    hours of pick up, you’ll be charged for the reserved period,
                    up to a maximum of one day's fee.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingbook15">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsebook15"
                    aria-expanded="false"
                    aria-controls="flush-collapsebook15"
                  >
                    <b>What is the policy for no shows?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsebook15"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingbook15"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      A booking is considered a no-show if the customer fails to
                      collect the rental within the first 6 hours of the
                      scheduled start time or by the end of the rental period,
                      whichever comes first.{" "}
                    </p>

                    <p>
                      In the event of a no-show, 100% of the booking amount will
                      be charged, and no refund will be issued.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading39">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse39"
                    aria-expanded="false"
                    aria-controls="flush-collapse39"
                  >
                    <b>
                      Should I ever use the keys to lock and unlock the vehicle?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse39"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading39"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. To do so may cause issues during your rental. The keys
                    must be left on the tether inside the vehicle at all times.
                    Please use the Hertz 24/7 app to lock and unlock the vehicle
                    during your rental.
                    <br />
                    NOTE: During inactivity, the vehicle immobiliser might come
                    on. To release this, please press the 'power' button on the
                    drive screen on the app, which appears between the lock and
                    unlock symbols.
                  </div>
                </div>
              </div>
              <br />
              <p id="yj">
                <b>Starting Your Rental</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading15">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse15"
                    aria-expanded="false"
                    aria-controls="flush-collapse15"
                  >
                    <b>How to unlock the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse15"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading15"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Once you press ‘Get virtual key’, the Hertz 24/7 app will
                      connect to the vehicle.
                    </p>
                    <p>
                      Once connected, you’ll see lock, unlock and immobiliser
                      button.
                    </p>
                    <p>
                      To open your vehicle, press the 'Unlock' button on the
                      drive tab during your rental.
                    </p>
                    Notes:
                    <br />
                    You will not be able to open the vehicle until the rental
                    period has officially started, inspection has been completed
                    and the contract signed. Make sure you have Bluetooth
                    enabled and are within 5 meters of the vehicle. If you get
                    Bluetooth activation error on iOS (&gt; 13) although your
                    Bluetooth is on, please go to 'Settings' app then into HERTZ
                    24/7 section and enable the Bluetooth option. If you’re
                    experiencing issues following switching Bluetooth on, please
                    close and reopen the app. 
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading16">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse16"
                    aria-expanded="false"
                    aria-controls="flush-collapse16"
                  >
                    <b>Where will I find the keys?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse16"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading16"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      The ignition key will either be in the glovebox or on a
                      tether under the steering wheel.
                    </p>
                    <p>
                      Use this key to start the engine and lock/unlock the
                      vehicle during your trip.
                    </p>

                    <p>If not there please check the other compartments.</p>

                    <p>
                      Please note that some models may not have a physical key
                      in which case you would press a button to turn the engine
                      on.
                    </p>

                    <p>
                      Please note that the key is not used to lock or unlock the
                      vehicle, it is only to be used to start the engine.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading17">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse17"
                    aria-expanded="false"
                    aria-controls="flush-collapse17"
                  >
                    <b>How do I start the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse17"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading17"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    On vehicles with an ignition lock, you will find the
                    ignition key in the glove compartment or on a chain near the
                    steering wheel. Depress the brake pedal (brake & clutch
                    pedal for manual transmission) and press the start button or
                    start the engine with the key. If the vehicle does not
                    start, the immobiliser might be on. In the Hertz 24/7 app on
                    the Drive screen, press the Power button to release the
                    immobiliser. The vehicle should start now.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading18">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse18"
                    aria-expanded="false"
                    aria-controls="flush-collapse18"
                  >
                    <b>What if the vehicle doesn't start?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse18"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading18"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The vehicle has a security feature that engages the
                    immobiliser if the ignition is off for more than 2 minutes.
                    To restart the engine, if immobilised, remove the key from
                    the ignition, use the app to remove the immobiliser by
                    pressing the 'power' icon on the drive screen (the icon
                    between the lock/unlock icons). Alternatively you can lock
                    and unlock the vehicle through the app. If the vehicle is
                    still doesn’t start, contact to our support team. They'll
                    either fix the problem remotely or find another vehicle for
                    you to use nearby. You can contact the team by chat via the
                    24/7 app.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading19">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse19"
                    aria-expanded="false"
                    aria-controls="flush-collapse19"
                  >
                    <b>How do I find the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse19"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading19"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Your Booking Confirmation includes details on where to find
                    the vehicle. This information is also available to you
                    online via the app. In the app you can select ‘Vehicle
                    Location’ and this will give an option to open a maps app
                    for directions to the vehicle. The app will generally have
                    the vehicles reg number (where applicable). Please ensure
                    you check the pick-up location’s opening hours and any
                    vehicle park restrictions before you book your vehicle. If
                    you intend to leave your own private vehicle at the site
                    please register this with partner staff at the
                    location. Hertz can not be held liable for any parking fines
                    issued at the rental location.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading20">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse20"
                    aria-expanded="false"
                    aria-controls="flush-collapse20"
                  >
                    <b>What if the vehicle I booked isn't there?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse20"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading20"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Please be sure to check the immediate surrounding area.
                    </p>

                    <p>
                      You can also use the 'locate vehicle' option which will
                      show the last known GPS location of the vehicle on a map.
                    </p>

                    <p>
                      If you’re still unable to locate your vehicle, or if it
                      shows in an area not in the immediate area of the location
                      please contact our support team via the chat in the app.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading22">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse22"
                    aria-expanded="false"
                    aria-controls="flush-collapse22"
                  >
                    <b>Does it matter if I pick up the vehicle late?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse22"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading22"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    You can collect the vehicle up to 6 hours of your planned
                    pick-up time. However, you will still be charged from the
                    original start time until the rental ends.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading24">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse24"
                    aria-expanded="false"
                    aria-controls="flush-collapse24"
                  >
                    <b>
                      What if the vehicles fuel tank is empty or is less than a
                      quarter full?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse24"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading24"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If the tank is less than a quarter full, please let us know
                    and refuel using the fuel card provided. You’ll find the
                    fuel card under the sun visor and the fuel card access PIN
                    code in the mobile app. If there’s no fuel at all in the
                    vehicle, or if you could not find the fuel card, please
                    contact our Member Care Center.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading25">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse25"
                    aria-expanded="false"
                    aria-controls="flush-collapse25"
                  >
                    <b>
                      What shall I do if I’ve exceeded the fuel card limit or
                      paid for fuel without the card?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse25"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading25"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    When refuelling the vehicle please ensure that you do not
                    exceed the limit shown on the fuel card. If you do exceed
                    the limit you will need to pay for the fuel yourself. You
                    will need to email the receipt to Hertz 24/7 Member Care
                    Center in order to receive a refund for fuel you have paid
                    for yourself. Please be aware that this may take several
                    days to process and is subject to a processing fee of £15 to
                    contribute towards the costs and expenses relating to the
                    refund where you have failed to follow the correct
                    refuelling process.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse29"
                    aria-expanded="false"
                    aria-controls="flush-collapse29"
                  >
                    <b>
                      What if I find something in the vehicle or leave something
                      of my own behind?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse29"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading29"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Not a problem. Please just contact our team and we’ll take
                    care of retrieving your item OR finding the previous renter
                    who left the item.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse30"
                    aria-expanded="false"
                    aria-controls="flush-collapse30"
                  >
                    <b>Do you provide child seats?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse30"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading30"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. However, you’re very welcome to use your own.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading41">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse41"
                    aria-expanded="false"
                    aria-controls="flush-collapse41"
                  >
                    <b>What do I do if I breakdown?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse41"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading41"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Please call our support team. You'll find our phone number
                    on the contact us page in the app. The AA can also be
                    reached directly on 0800 289 494
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL44">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL44"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL44"
                  >
                    <b>
                      I've started the vehicle, but there are dashboard lights
                      that come up. What do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL44"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL44"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    There are various dashboard signals that may indicate an
                    issue with the vehicle. If you notice any of these, please
                    contact the AA.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj22">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj22"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj22"
                  >
                    <b>How do I extend my rental? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj22"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj22"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    You can easily extend your rental via the app subject to
                    availability of vehicles. Follow the steps after tapping the
                    'Extend rental' button on the drive tab during your rental. 
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj23">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj23"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj23"
                  >
                    <b>
                      I’m having trouble with opening the side or rear door of
                      the vehicle. What should I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj23"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj23"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Most vehicles have a button to unlock the rear doors,
                      typically located in one of the following places:
                    </p>

                    <p>
                      Inside the driver’s door panel – Look for a button with a
                      padlock symbol.{" "}
                    </p>

                    <p>
                      On the center console – Some models place the rear door
                      unlock control here.{" "}
                    </p>

                    <p>
                      The exact location and design of the button can vary
                      depending on the make and model of your vehicle.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj24">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj24"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj24"
                  >
                    <b>
                      There is excessive damage on the vehicle, what do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj24"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj24"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If there is excessive damage on your vehicle and you don’t
                    believe it is safe to drive, please reach out to our support
                    team via chat in the app, who will assign you a new vehicle.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj25">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj25"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj25"
                  >
                    <b>
                      I’ve taken the inspection photos however now that I have
                      opened the vehicle there is rubbish inside, what do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj25"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj25"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Although we work hard to keep our vehicles clean and
                    well-maintained for every trip, it is important to note that
                    this is a vehicle-sharing service – therefore the vehicle
                    may occasionally have some dirt or leftover rubbish from
                    previous users. If you are unhappy with the condition of the
                    vehicle, please reach out to us on chat support via the app
                    to let us know.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj26"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj26"
                  >
                    <b>
                      I’m having issues taking the vehicle inspection photos,
                      what do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj26"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj26"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sometimes the uploading process can take some time following
                    taking your inspection photos, particularly if there is low
                    network. When you take your final photo, please note it may
                    take a few minutes for your images to upload.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj27"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj27"
                  >
                    <b>
                      There is not a lot of space around the vehicle to take the
                      photos, what do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sometimes the vehicle may not have much room for the photo
                    check, for example it may be parked tightly between other
                    vehicles. If this is the case, just do your best to take the
                    required photos. You should still be able to proceed with
                    accessing the vehicle.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj28">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj28"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj28"
                  >
                    <b>
                      Why do I need to take inspection photos of the vehicle?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj28"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj28"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    In order to capture the state of the vehicle at the start of
                    the rental, we require you to take six images. At the end of
                    the rental we request another set of six images so that we
                    can do a comparison. If any new damage is found during your
                    rental, you’ll be liable for this and can get charged up to
                    the excess amount.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj29"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj29"
                  >
                    <b>
                      I’m having trouble signing the rental agreement, please
                      help?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj29"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj29"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      If you’re having trouble signing the rental agreement,
                      please make sure to address the following:{" "}
                    </p>

                    <p>
                      The preregistration selfie needs to match the image of the
                      account holder in the account{" "}
                    </p>

                    <p>
                      Deposit authorisation needs to be successfully put on hold
                      from the bank account{" "}
                    </p>

                    <p>You need to be close to vehicle </p>

                    <p>
                      Bluetooth needs to be enabled and location services must
                      be set to active{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj30"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj30"
                  >
                    <b>How do I sign the rental agreement?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj30"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj30"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>There are two ways to sign your rental agreement. </p>

                    <p>Biometrics using finger print scanner </p>

                    <p>
                      Alternatively, there will be a pop-up which requires you
                      to write ‘I Agree’ in order to sign the rental
                      agreement.{" "}
                    </p>

                    <p>
                      Once signed, an email with the PDF of the rental agreement
                      will be send and you’ll also find the rental agreement
                      under ‘Documents’ in the app.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingyj31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseyj31"
                    aria-expanded="false"
                    aria-controls="flush-collapseyj31"
                  >
                    <b>When can I start the rental?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseyj31"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingyj31"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Around 15 minutes before the rental a vehicle is assigned to
                    your rental and you can start the process of vehicle
                    inspection and signature of the rental agreement.
                  </div>
                </div>
              </div>
              <br />
              <p id="bfi">
                <b>Billing and fees</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading47">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse47"
                    aria-expanded="false"
                    aria-controls="flush-collapse47"
                  >
                    <b>Are there any extra charges I need to be aware of?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse47"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading47"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes. There’s a mileage rate on every booking. If you damage
                    the vehicle, there’s an insurance excess to pay. This is
                    £1000 on cars or £1200 on vans. Gross Negligence (e.g. roof
                    damage, ad-blue or fuel contamination) and Vehicle Abuse is
                    not covered by the Collision Damage Waiver and Third Party
                    Insurance that are covered in the vehicle rental rate
                  </div>
                </div>
              </div>

              <br />
              <p id="aob">
                <b>Accidents/Breakdowns</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL51">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL51"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL51"
                  >
                    <b>
                      Do I pay a fee if the vehicle is towed away or clamped?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL51"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL51"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    We'll pay the fine at first and then add it to your invoice,
                    together with a £42 admin fee.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL52">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL52"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL52"
                  >
                    <b>
                      What should I do if I notice the clutch is sticking or
                      smell smoke?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL52"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL52"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you notice that the clutch is sticking or there’s a smell
                    of smoke, you should call the AA immediately. Do not
                    continue driving the vehicle, as doing so could cause
                    further damage and you may be held liable for any resulting
                    charges. We will not provide a replacement vehicle until an
                    investigation has been completed. Once the AA has assessed
                    the situation, please inform the fleet team of their
                    findings—they may instruct you to apply the excess. In most
                    cases, the issue is due to the clutch being burnt out, but
                    the AA will not be able to confirm on the spot whether the
                    fault lies with the vehicle or with the driver. In the
                    meantime, make sure to schedule the vehicle for inspection
                    and move any upcoming bookings.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL53">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL53"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL53"
                  >
                    <b>What should I do if I feel the gears are slipping?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL53"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL53"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you feel that the gears are slipping, you should also
                    contact the AA right away. The fleet team typically does not
                    offer an alternative van in these situations, but they will
                    make a decision on a case-by-case basis. Once you receive
                    feedback from the AA, send an email to the fleet team with
                    the details. Avoid making any promises or offering
                    compensation to the member until the issue has been fully
                    investigated. Rental charges will continue to apply until
                    the fleet team confirms whether the issue is due to a fault
                    with the vehicle or driver error. As with other mechanical
                    issues, be sure to schedule the vehicle and move any
                    upcoming bookings.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingXL54">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL54"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL54"
                  >
                    <b>What should I do if I suspect fuel contamination?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL54"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL54"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you suspect fuel contamination—such as accidentally
                    putting petrol into a diesel van—and the vehicle breaks
                    down, you may see a red engine warning light, hear unusual
                    noises, or experience the van stopping and starting. It’s
                    critical that you stop driving immediately. Ask yourself if
                    you’ve refuelled recently and whether the correct fuel type
                    was used. If you’re unsure, call the AA straight away. Do
                    not attempt to drive the vehicle, as doing so could result
                    in severe damage and repair costs that exceed the insurance
                    excess. If the issue is caught early and the fuel can be
                    drained easily, the penalty is £485.00.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlaob51">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlaob51"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlaob51"
                  >
                    <b>
                      Will my personal vehicle insurance cover my damage fee?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlaob51"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlaob51"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. Your personal vehicle insurance isn’t valid for Hertz
                    24/7 vehicles. Our vehicles are only covered by the
                    insurance policies we provide or make available in relation
                    to your booking.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading46">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse46"
                    aria-expanded="false"
                    aria-controls="flush-collapse46"
                  >
                    <b>
                      Will I be asked to pay a late return fee if the vehicle
                      breaks down?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse46"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading46"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. In the highly unlikely event of a breakdown, you won’t
                    be liable for any extra charges (unless you caused the
                    breakdown of course). 24-hour Emergency Roadside Assistance
                    is included in your booking.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading43">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse43"
                    aria-expanded="false"
                    aria-controls="flush-collapse43"
                  >
                    <b>What should I do if the vehicle is stolen?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse43"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading43"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    You must notify us immediately via chat. You will find the
                    chat in the contact section.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlaob43">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlaob43"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlaob43"
                  >
                    <b>How do I report an accident or new damage? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlaob43"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlaob43"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Please contact the Hertz 24/7 team immediately using the
                    contact details in the 'Support' section of the mobile app.
                    We’ll then take care of everything. Just be sure to get the
                    details of the third party involved in the accident and to
                    take photos of the damage done to both vehicles. Failure to
                    report any incident may invalidate your insurance cover. 
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading42">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse42"
                    aria-expanded="false"
                    aria-controls="flush-collapse42"
                  >
                    <b>What do I do if I have an accident / incident?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse42"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading42"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Please contact the Hertz 24/7 team immediately using the
                    contact details in the 'help' section of the mobile app.
                    We’ll then take care of everything. Just be sure to get the
                    details of the third party involved in the accident and to
                    take photos of the damage done to both vehicles. Failure to
                    report any incident may invalidate your insurance cover.
                  </div>
                </div>
              </div>
              <br />
              <p id="cg">
                <b>Community Guidelines/Vehicle Sharing Rules</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse26"
                    aria-expanded="false"
                    aria-controls="flush-collapse26"
                  >
                    <b>Can I smoke inside the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse26"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading26"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. Please don’t smoke inside any Hertz 24/7 vehicle. Our
                    vehicles have been classified as strictly non-smoking areas
                    since 1 May 2013. It’s part of our drive to provide a safe,
                    clean fleet for all of our employees and customers. Thank
                    you for your consideration. A cleaning fee of £50 will be
                    added to your invoice if we find evidence of smoking inside
                    the vehicle during your rental period.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL26"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL26"
                  >
                    <b>
                      Are there any age or license requirements to rent a
                      vehicle?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL26"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL26"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    You must be 21 years of age or over to hire and drive one of
                    our vehicles. You also need to have held a full driving
                    licence for at least a year and have had no suspensions in
                    the last 5 years.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse31"
                    aria-expanded="false"
                    aria-controls="flush-collapse31"
                  >
                    <b>Am I allowed to carry pets in the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse31"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading31"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. Pets aren’t permitted in our vehicles – except for guide
                    dogs and hearing dogs.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlcg31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlcg31"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlcg31"
                  >
                    <b>What should I do before returning the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlcg31"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlcg31"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Before returning the vehicle, please ensure the following:
                    </p>

                    <p>
                      The vehicle is clean and free of personal items and
                      rubbish.{" "}
                    </p>

                    <p>The fuel card is placed back in the vehicle. </p>

                    <p>
                      The key is returned to its designated location inside the
                      vehicle.{" "}
                    </p>

                    <p>
                      The vehicle is returned to the correct designated parking
                      spot.{" "}
                    </p>

                    <p>
                      You return the vehicle on time, before the grace period
                      ends.{" "}
                    </p>

                    <p>
                      No smoking or pets were in the vehicle during your
                      rental.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading33">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse33"
                    aria-expanded="false"
                    aria-controls="flush-collapse33"
                  >
                    <b>What if the vehicle isn’t clean inside or out?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse33"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading33"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    We do ask our customers to leave the vehicle clean and tidy
                    at the end of each rental. We also maintain our fleet of
                    vehicles on a regular basis. However, please do let us know
                    if you’re unhappy with the vehicles condition.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading32">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse32"
                    aria-expanded="false"
                    aria-controls="flush-collapse32"
                  >
                    <b>Do I have to clean the vehicle when I return it?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse32"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading32"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes. For the benefit of the next customer, please make sure
                    the inside of the vehicle is in a clean condition at the end
                    of your rental. If a vehicle is returned in an unclean
                    condition, you may be subject to a penalty.
                  </div>
                </div>
              </div>
              <br />
              <p id="pac">
                <b>Pricing and Additional Charges</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL27"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL27"
                  >
                    <b>How is pricing calculated?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Rental pricing depends on your location, vehicle type, and
                    the season. Hertz 24/7 offers hourly, daily, and multi-day
                    rates, with bookings made in 15-minute increments and
                    charged by the hour. A 15-minute grace period is allowed for
                    late returns, but going over your booking without extending
                    may result in being charged for any additional hours plus a
                    late fee.Please note, for IKEA Family members, Costco
                    members and B&Q clubcard holders there are special offer
                    rates. Please add your loyalty card number to your booking
                    to avail of it.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl28">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL28"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL28"
                  >
                    <b>
                      How do I add my B&Q/IKEA/Costco clubcard number to my
                      booking?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL28"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL28"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    When confirming your rental, under the add a payment section
                    there is a section called ‘Discount & Loyalty Programs’
                    where you can add your clubcard number.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL29"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL29"
                  >
                    <b>Are there any extra charges I should be aware of?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL29"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL29"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes, there are a few potential additional charges to keep in
                    mind as follows:
                    <br />
                    · Late Returns: You have a 15-minute grace period. If you
                    return the vehicle late without extending your booking, you
                    will be charged a fixed hourly rate and a standard late fee.
                    <br />
                    · Fuel: Fuel is charged per mile and shown at booking. If
                    the fuel card is missing or not used correctly, and you pay
                    out of pocket, a £15 processing fee may apply when claiming
                    reimbursement.
                    <br />
                    · Payment Holds: A hold of twice your rental amount is
                    placed at the start. If the full hold isn’t available, the
                    rental can’t begin.
                    <br />
                    · Cancellations & No-Shows: Cancelling within 6 hours of
                    your booking or failing to show up may result in a charge of
                    up to one full day.
                    <br />
                    · Tolls & Fines: You’re responsible for any tolls, speeding
                    tickets, parking fines, or ferry fees incurred during your
                    rental.
                    <br />
                    · Insurance Excess: In case of damage, loss, or theft,
                    you’re liable for an insurance excess (£1,000 for cars,
                    £1,200 for vans) per incident. Optional insurance products
                    to reduce the excess are shown at time of booking. Gross
                    negligence (like roof damage or fuel contamination) isn’t
                    covered.
                    <br />
                    · Roadside Assistance Misuse: While 24/7 roadside assistance
                    is included, charges may apply if the issue is due to misuse
                    or negligence.
                    <br />· Mileage Fee: There is a mileage fee of 35 pence per
                    mile.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseXL30"
                    aria-expanded="false"
                    aria-controls="flush-collapseXL30"
                  >
                    <b>
                      Is Ulez (London Ultra Low Emission Zone) included in my
                      booking?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapseXL30"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingXL30"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    As most of our vans are new, they are exempt from this
                    charge. However, you can check the registration and whether
                    this charge is required to be paid on the gov.co.uk website.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading28">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse28"
                    aria-expanded="false"
                    aria-controls="flush-collapse28"
                  >
                    <b>Do I have to pay any Congestion Charges?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse28"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading28"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. We’ve taken care of that already.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlpac46">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlpac46"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlpac46"
                  >
                    <b>
                      Will I be asked to pay a late return fee if the vehicle
                      breaks down?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlpac46"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlpac46"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. In the highly unlikely event of a breakdown, you won’t
                    be liable for any extra charges (unless you caused the
                    breakdown of course). 24-hour Emergency Roadside Assistance
                    is included in your booking.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse27"
                    aria-expanded="false"
                    aria-controls="flush-collapse27"
                  >
                    <b>
                      What happens if I get a speeding ticket or parking fine?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    As you would expect, things like tolls, speeding tickets,
                    parking fines and ferry fees are your responsibility to pay.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlpac27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlpac27"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlpac27"
                  >
                    <b>How do I read my invoice?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlpac27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlpac27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Your invoice can be comprised of your hourly fee multiplied
                    by the number of hours, insurance you may have bought, miles
                    driven and any fees or fines accrued during your rental.
                  </div>
                </div>
              </div>
              <br />
              <p id="rac">
                <b>Refuelling and Charging</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading23">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse23"
                    aria-expanded="false"
                    aria-controls="flush-collapse23"
                  >
                    <b>Who pays for the fuel cost?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse23"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading23"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Fuel will be charged on a pence per mileage basis,
                      displayed at the time of booking.
                    </p>

                    <p>
                      All vehicles come with a fuel card under the sun visor and
                      at least a quarter tank of fuel at the beginning of the
                      rental. You should return the vehicle this way too. If the
                      fuel card is missing at the beginning of the rental please
                      contact us via the chat in the Help section of the app.
                    </p>

                    <p>
                      There is a £50 per transaction limit on the fuel card
                      provided. Fuel cards can be used at Shell, Esso or Texaco
                      fuel stations and the pin code displayed in the app will
                      be required when paying for fuel. Please utilise up to the
                      full transaction limit when refillng using the vehicle
                      fuel card to help future renters. You are only charged for
                      the mileage driven in the vehicle, not on the fuel card
                      usage.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl23">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl23"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl23"
                  >
                    <b>
                      What if the vehicles fuel tank is empty or is less than a
                      quarter full?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl23"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl23"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If the tank is less than a quarter full, please let us know
                    and refuel using the fuel card provided. You’ll find the
                    fuel card under the sun visor and the fuel card access PIN
                    code in the mobile app. If there’s no fuel at all in the
                    vehicle, or if you could not find the fuel card, please
                    contact our support team.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl24">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl24"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl24"
                  >
                    <b>Do I need to refuel before returning the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl24"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl24"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes, please return the vehicle with at least a quarter tank
                    of fuel. If returned below there might be a fine applied.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl25">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl25"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl25"
                  >
                    <b>How do I use the fuel card?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl25"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl25"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The card can be used at Shell, Esso or Texaco stations and
                    has a £50 per transaction limit. You’ll need to provide the
                    vehicle registration (on the card) and mileage when
                    refuelling. The PIN for the card is available in the app.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl26"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl26"
                  >
                    <b>What if the fuel card is missing or doesn’t work?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl26"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl26"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If the card is unavailable or not functioning, contact
                    support. You may pay for fuel yourself and request
                    reimbursement by submitting a receipt over email to our
                    support team. Please note, a £15 processing fee may apply if
                    the correct refuelling process isn’t followed.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl27"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl27"
                  >
                    <b>
                      What shall I do if I’ve exceeded the fuel card limit or
                      paid for fuel without the card?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    When refuelling the vehicle please ensure that you do not
                    exceed the £50 limit. If you do exceed the limit you will
                    need to pay for the fuel yourself. You will need to email
                    the receipt to Hertz 24/7 support team to receive a refund
                    for fuel you have paid for yourself. Please be aware that
                    this may take several days to process and is subject to a
                    processing fee of £15 to contribute towards the costs and
                    expenses relating to the refund where you have failed to
                    follow the correct refuelling process.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl28">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl28"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl28"
                  >
                    <b>My Adblue level is low. What do I do?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl28"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl28"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you’re seeing a notification that your Adblue level is
                    low, please feel free to use the fuel card to buy Adblue and
                    fill this yourself if you are comfortable. If you are
                    uncomfortable doing this, please call AA.
                  </div>
                </div>
              </div>

              <br />
              <p id="consup">
                <b>Contact Support</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlcs28">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlcs28"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlcs28"
                  >
                    <b>How do I contact support?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlcs28"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlcs28"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Please note that for Hertz 24/7 we do not provide phone
                    support. You can contact a support agent via chat in the
                    24/7 app.
                  </div>
                </div>
              </div>

              <br />
              <p id="ts">
                <b>Troubleshooting</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlts28">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlts28"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlts28"
                  >
                    <b>
                      What should I do if I can’t connect to or access my
                      vehicle?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlts28"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlts28"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      If you're having trouble connecting to or accessing your
                      Hertz 24/7 vehicle, there are a few quick checks you can
                      do before reaching out for support.
                    </p>

                    <p>
                      Make sure your account is fully verified and that your
                      payment or deposit has been successfully processed.{" "}
                    </p>

                    <p>
                      Make sure your Bluetooth is switched on and you are within
                      5 metres of the vehicle.{" "}
                    </p>

                    <p>
                      If you switched on Bluetooth, please close and re-open the
                      app before attempting to get the virtual key{" "}
                    </p>

                    <p>
                      If you are using a second driver on the booking, make sure
                      the other driver has closed the app and is no longer
                      connected to the vehicle
                    </p>

                    <p>
                      Please also try to close and reopen the app for
                      troubleshooting purposes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlts29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlts29"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlts29"
                  >
                    <b>
                      What should I do if I’m still stuck after troubleshooting?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlts29"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlts29"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If none of the troubleshooting steps resolve the issue, you
                    can contact the Hertz 24/7 support team directly through the
                    app. Simply tap the ‘?’ icon, select “Contact Support,” and
                    send a message. A member of the team will be happy to assist
                    you and help get you back on the road as quickly as
                    possible. 
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlts30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlts30"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlts30"
                  >
                    <b>
                      I’m trying to return the vehicle/close the rental and I’m
                      at the designated parking bay, but the app is not
                      recognizing that I’m at the appropriate location. What do
                      I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlts30"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlts30"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you’re unable to return the vehicle/close the rental
                    despite being in the correct location, please contact
                    support via the app.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlts31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlts31"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlts31"
                  >
                    <b>What if the vehicle won’t start?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlts31"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlts31"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      If the engine has been off for more than 2 minutes, the
                      immobiliser may have activated.
                    </p>

                    <p>
                      Remove the key, then use the app to unlock or lock the
                      vehicle, or press the “Immobilizer” (power) icon.
                    </p>

                    <p>
                      Make sure Bluetooth is enabled and try restarting the
                      app.{" "}
                    </p>

                    <p>
                      Still stuck? Contact our support via chat in the app —
                      they can assist remotely or arrange another vehicle
                      nearby.
                    </p>
                  </div>
                </div>
              </div>

              <br />
              <p id="rvet">
                <b>Returning the Vehicle/Ending Your Trip</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading35">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse35"
                    aria-expanded="false"
                    aria-controls="flush-collapse35"
                  >
                    <b>How do I extend my rental?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse35"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading35"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    You can easily extend your rental via the app subject to
                    availability of vehicles. Follow the steps after tapping the
                    'Extend rental' button on the drive tab during your rental. 
                    <br />
                    However if the vehicle is needed for an upcoming rental, you
                    might not be able to extend. Also ensure there is enough
                    funds available on your method of payment to cover the
                    deposit hold for the extension.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlrvet37">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlrvet37"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlrvet37"
                  >
                    <b>
                      I’m at the designated parking bay, but the app won’t let
                      me close the rental. What should I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlrvet37"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlrvet37"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      If you’re at the correct designated parking bay but the
                      app is not recognizing your location and won’t allow you
                      to end the rental, please follow these steps:
                    </p>

                    <p>
                      Double-check your location:
                      <br />
                      Ensure you are within the marked zone of the designated
                      parking area. Sometimes being just outside the boundary
                      can cause issues.
                    </p>

                    <p>
                      Check your phone’s location settings:
                      <br />
                      Make sure your phone’s GPS is enabled and that the app has
                      permission to access your location.
                    </p>

                    <p>
                      Refresh the app:
                      <br />
                      Try closing and reopening the app to see if it updates
                      your location.
                    </p>

                    <p>
                      Still not working?
                      <br />
                      If the issue persists, please contact support via the
                      in-app chat. Our team will assist you promptly.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading36">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse36"
                    aria-expanded="false"
                    aria-controls="flush-collapse36"
                  >
                    <b>Where should I return the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse36"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading36"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Please return the vehicle to the Hertz 24/7 designated
                    parking bay at the location or close to where you have
                    picked up the vehicle. If you are parked in the designated
                    parking bay and you cannot close your rental, please reach
                    out to us via chat support.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading34">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse34"
                    aria-expanded="false"
                    aria-controls="flush-collapse34"
                  >
                    <b>Can I return the vehicle early?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse34"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading34"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes. You can return the vehicle at any time during your
                    rental period. However, you’ll still be charged for the
                    whole booking period.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlrvet34">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapservet34"
                    aria-expanded="false"
                    aria-controls="flush-collapservet34"
                  >
                    <b>How do I return the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapservet34"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingrvet34"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    To end your rental, return the vehicle to the original
                    pickup location and park in the designated bay. Remove all
                    personal items and rubbish, and refill the fuel to the
                    required level. Place the key and fuel card back in the
                    vehicle, ensure all lights are off, windows and doors are
                    closed, and the ignition is off. Then, use the app to lock
                    the vehicle and tap “Close Rental” to end your trip. After
                    return, an invoice will be issued based on mileage and
                    condition. Any unused balance from the initial payment hold
                    will be released. 
                  </div>
                </div>
              </div>

              <br />
              <p id="pi">
                <b>Parking Information</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlpi1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlpi1"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlpi1"
                  >
                    <b>
                      I’m trying to return my vehicle, but the gate is closed.
                      What do I do?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlpi1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlpi1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you’re trying to return the vehicle but the gate to the
                    vehicle park is closed, please contact us via chat in the
                    app. Please take care not to block the location gates or
                    access points when parking the vehicle.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading21">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse21"
                    aria-expanded="false"
                    aria-controls="flush-collapse21"
                  >
                    <b>What happens if I return the vehicle late?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse21"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading21"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you overrun your allocated time slot without extending
                    your rental beforehand, you’ll be charged. Please note that
                    there is a 15-minute grace period in order to close your
                    rental.  If you are later than the grace period, you will be
                    charged for each hour that you are late plus a late return
                    fee.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxlpi2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexlpi2"
                    aria-expanded="false"
                    aria-controls="flush-collapsexlpi2"
                  >
                    <b>
                      I'm running late to return my vehicle. Will the location
                      be open and accessible? 
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexlpi2"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxlpi2"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Some Hertz 24/7 rental locations have gates that lock during
                    certain hours, typically overnight. If you anticipate
                    returning or need to extend your rental, it’s important to
                    check the gate hours in advance. This information is
                    available in the Hertz 24/7 app under your booking details.
                    If you're unsure, you can also contact the rental location
                    directly to avoid being locked out or incurring additional
                    charges.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading37">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse37"
                    aria-expanded="false"
                    aria-controls="flush-collapse37"
                  >
                    <b>What if my designated parking bay is already taken?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse37"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading37"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Please park the vehicle in the bay closest to the Hertz 24/7
                    bay.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingpi3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsepi3"
                    aria-expanded="false"
                    aria-controls="flush-collapsepi3"
                  >
                    <b>Where should I return the rental vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsepi3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingpi3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    When returning your Hertz 24/7 vehicle, it must be parked in
                    the designated Hertz 24/7 parking bay at the rental
                    location. If that specific bay is occupied, you should park
                    the vehicle in the nearest available bay to the designated
                    one. This helps ensure a smooth handover for the next renter
                    and avoids confusion or penalties. If there is no dedicated
                    bay, please park close to where you picked up the vehicle.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingpi4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsepi4"
                    aria-expanded="false"
                    aria-controls="flush-collapsepi4"
                  >
                    <b>
                      Can I leave my personal vehicle at the rental location? 
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsepi4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingpi4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes, you can leave your personal vehicle at the rental
                      location during your trip, but it will be subject to local
                      parking restrictions. Always check for signage in the
                      vehicle car park or inside the store to ensure compliance.
                      If in doubt please check with location staff if
                      possible.{" "}
                    </p>

                    <p>
                      Make sure to check the 24/7 app for the opening hours of
                      the carpark, essential information such as gate codes,
                      specific parking bay details, and any other
                      location-specific guidance to help you access and return
                      your vehicle smoothly.  Please note that if there is a
                      gate code for the location, this will show once the rental
                      agreement is signed. It’s best to take note of this/take a
                      screenshot as this will disappear after 15 minutes.{" "}
                    </p>

                    <p>
                      Please note that any fines or penalties incurred while
                      your vehicle is parked are your responsibility as the
                      renter.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingpi5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsepi5"
                    aria-expanded="false"
                    aria-controls="flush-collapsepi5"
                  >
                    <b>
                      How can I find parking information for my rental location?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsepi5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingpi5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      When you are making a booking, additional location
                      information is shown under the (i) icon.{" "}
                    </p>

                    <p>
                      For an existing booking, additional location information
                      is show after pressing the ‘Vehicle location’ button. This
                      contains information on the parking bay, opening hours and
                      any parking restrictions.{" "}
                    </p>
                  </div>
                </div>
              </div>

              <br />
              <p id="ins">
                <b>Insurance</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSC">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSC"
                    aria-expanded="false"
                    aria-controls="flush-collapseSC"
                  >
                    <b>SuperCover UK</b>
                  </button>
                </h2>
                <div
                  id="flush-collapseSC"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingSC"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    If you opted for, or if your rate includes Collision Damage
                    Waiver (CDW) and Theft Protection (TP), you may also wish to
                    purchase an additional protection, "SuperCover", to waive or
                    further reduce your already limited liability in case of
                    damage to, or theft of the Hertz vehicle , including those
                    losses resulting from collision, vandalism, theft or
                    attempted theft, provided the vehicle is used in accordance
                    with the terms and conditions of the Rental Agreement.
                    <br />
                    <br />
                    <p>
                      Please note the terms and conditions and limitations below
                      which apply to SuperCover.
                    </p>
                    <p>SuperCover does not cover:</p>
                    <p>
                      1. Accessories you rent in addition to the vehicle (e.g.
                      Hertz NeverLost and other portable navigation units,
                      portable WiFi units, child seats, etc.). You will be
                      charged for replacement of these items if they are lost or
                      damaged for any reason.
                    </p>
                    <p>
                      2. Removable parts of the vehicle if they are missing at
                      time of return such as keys and key fobs, luggage covers
                      and nets, charging cables for PHEV or EV’s, warning vests
                      and triangles, SD GPS cards, spare wheels, tools and tyre
                      inflation devices, 1st aid boxes, fire extinguishers, etc.
                      You will be charged for replacement of these items unless
                      the vehicle was involved in an accident or third party
                      theft.
                    </p>
                    <p>
                      Please note your liability for damage to, or loss of, the
                      vehicle will not be waived or reduced in the following
                      circumstances and you will remain liable for the full loss
                      and/or damage:
                    </p>
                    <p>
                      1. where you or the authorised driver are in breach of
                      your obligations under the Rental Agreement (your
                      attention is particularly drawn to the Rental Restrictions
                      section of the Rental Terms);
                    </p>
                    <p>2. if the loss or damage is caused intentionally;</p>
                    <p>
                      3. if the driver was not authorised by Hertz as the main
                      or additional driver; or
                    </p>
                    <p>
                      4. if the main or the additional driver is negligent (for
                      example failure to assess the vehicle’s height, driving on
                      unsuitable road conditions, improper use of the vehicle,
                      contribution to damage to/theft of the vehicle) and in
                      particular, but not limited to, the following
                      circumstances:
                    </p>
                    <ul>
                      <li>Striking overhead or overhanging objects; </li>
                      <li>
                        Driving into a barrier that is too low for the vehicle
                        to pass beneath;
                      </li>
                      <li>
                        Driving into a barrier in a car park before it fully
                        opens;
                      </li>
                      <li>
                        Driving on a road in bad condition without due care
                        resulting in damage to the undercarriage;
                      </li>
                      <li>
                        Driving on a beach causing damage by salt water and/or
                        sand;
                      </li>
                      <li>
                        Driving through flooded roads causing damage to the
                        engine;
                      </li>
                      <li>
                        Putting wrong fuel in the vehicle or otherwise
                        contaminating the fuel;
                      </li>
                      <li>
                        Damage occurring as a result of ignoring a warning
                        light;
                      </li>
                      <li>
                        Burning a clutch (which requires persistent ill use) or
                        using the handbrake incorrectly;
                      </li>
                      <li>
                        Damage to the wheel rim caused by driving with a flat
                        tyre;
                      </li>
                      <li>
                        Fitting unauthorised objects to the interior or exterior
                        of the vehicle;
                      </li>
                      <li>
                        Carrying especially dirty or smelly materials that
                        require extra cleaning costs or that damage or burn the
                        interior;
                      </li>
                      <li>
                        Damage resulting from locking the keys in the vehicle or
                        losing the keys;
                      </li>
                      <li>Damage resulting from leaving the windows open;</li>
                      <li>
                        Loss of the vehicle caused by failure to use the
                        anti-theft system (if provided);
                      </li>
                      <li>
                        Loss of the vehicle when you are unable to return the
                        key.
                      </li>
                    </ul>
                    <p>
                      SuperCover is not available for customers on business
                      contract rate rentals unless there is a CDP code present
                      that indicates that this option is applicable.
                    </p>
                    SuperCover is not available for the following vehicle
                    groups: <br />
                    (A5) Porsche Boxster 718 (C5) Porsche Cayenne S (D5) R.
                    Rover Sport Supercharged (E5) Audi R8 Spider (F5) Bentley
                    GTC Speed (G5) Porsche 992 4S (H5) Audi Q7 TDI Quattro (I5)
                    Mercedes V Class Extra LWB (J5) Porsche Panamera 4S (K5)
                    Land Rover Range Rover Velar (L5) R. Rover Autobiography LWB
                    (X5) Mercedes C63 AMG Commercial vans and trucks (except
                    24/7 rentals)
                    <br />
                    <br />
                    <p>
                      SuperCover is offered in most locations It is not included
                      in the rental rate but can be purchased for the additional
                      amount shown in the reservation and booking process or
                      quoted at the counter at the time of pick up. You can book
                      SuperCover online but it is payable at the counter at the
                      time of pick up (or via the app/website if you are booking
                      a 24/7 rental).
                    </p>
                    <br />
                    24/7/ Rentals:
                    <br />
                    For 24/7 rentals, please be aware that purchasing SuperCover
                    does not eliminate the excess – in the event of an accident
                    or theft you will still be required to pay an excess but
                    this will be a lower amount than where SuperCover does not
                    apply. For your convenience we offer two options for 24/7,
                    SuperCover Light (this has a lower hourly price but a higher
                    excess amount applies) and SuperCover Premium (this has a
                    greater hourly price but a lower excess amount applies).
                    Please see the prices and excess amounts in the booking
                    flow. The restrictions above apply to both products.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading51">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse51"
                    aria-expanded="false"
                    aria-controls="flush-collapse51"
                  >
                    <b>
                      Can I rely on my credit card provider’s insurance scheme
                      to cover any damage?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse51"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading51"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    It’s best to check with your credit card provider before you
                    make your Hertz 24/7 booking as different credit cards have
                    different insurance protection schemes.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading48">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse48"
                    aria-expanded="false"
                    aria-controls="flush-collapse48"
                  >
                    <b>
                      Will my personal vehicle insurance cover my damage fee?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse48"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading48"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    No. Your personal car insurance isn’t valid for Hertz 24/7
                    vehicles. Our vehicles are only covered by the insurance
                    policies we provide or make available in relation to your
                    booking.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading50">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse50"
                    aria-expanded="false"
                    aria-controls="flush-collapse50"
                  >
                    <b>What does the insurance on my booking cover me for?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse50"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading50"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The insurance covers you for damage to the vehicle, over and
                    above the excess amount. The excess is the maximum you are
                    liable to pay in the event of a claim. Provided you follow
                    the terms and conditions of Your Rental Agreement, you'll
                    also be protected by Third Party Liability Insurance, which
                    is included as standard and is required by law. This covers
                    you for damage to other vehicles, other property and injured
                    parties in the event of an accident. If vehicle loss, damage
                    or theft is caused intentionally. If you put the wrong fuel
                    into the vehicle, contaminate the fuel tank or contaminate
                    the Ad blue tank all such damage will be categorised as
                    gross negligence and you will be liable for the cost of
                    repair. If the vehicle is stolen you will only be charged
                    the excess amount.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl49">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl49"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl49"
                  >
                    <b>
                      Do I need insurance add-ons like Supercover, Collision
                      Damage Waiver or Theft Protection?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl49"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl49"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Although this is not required, most customers opt for this
                    protection because it offers complete peace of mind. It
                    covers you against costly damage, theft, or
                    accidents—potentially saving you over £1,000 in excess
                    fees—while also ensuring faster support and no hassle if
                    something goes wrong.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl50">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl50"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl50"
                  >
                    <b>What is SuperCover (SC)?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl50"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl50"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    SuperCover reduces or removes the N.W.E. amount, meaning
                    your excess is reduced or fully covered in case of damage.
                    However, exceptions apply—please refer to the Terms and
                    Conditions for details.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row shadow-lg p-3 mb-5 bg-body rounded">
          <a href="https:/l.ead.me/beWm77">
            <img
              className="img-fluid rounded-4"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/App_Banner-new-format%20EN.png"
              alt=""
              style={{
                width: "100vw",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          </a>
        </div>
      </div>
    </>
  );
}

export default FAQBody;
